import React from 'react';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Services from './components/Services';
import OtherServices from './components/OtherServices';
import MemberArea from './components/MemberArea';
import Pricing from './components/Pricing';
import Portfolio from './components/Portfolio';
import Contact from './components/Contact';
import Footer from './components/Footer';
import { Toaster } from './components/ui/sonner';
import './App.css';

function App() {
  return (
    <div className="App">
      <Navbar />
      <Hero />
      <Services />
      <OtherServices />
      <MemberArea />
      <Pricing />
      <Portfolio />
      <Contact />
      <Footer />
      <Toaster />
    </div>
  );
}

export default App;
